// Chart.js and its date adapter are downloaded only when a page draws its first chart.
let chartJs;

export const loadChart = () => (chartJs ??= import('./chart-setup.js').then(m => m.Chart));
